module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/app/@propnow/locales/bhs/en.json
// module id = 447
// module chunks = 244